import React from "react";
import styled from "styled-components";

const CallButtonGroup = styled.div`
    display: flex;
    gap: 0.75em;
`

export default CallButtonGroup
